import { FC, useContext } from 'react';

// Components
import RoundDropdown from './RoundDropdown';
import Image from '../../../../../packages/HOC/AccessibilityImage';

// Utils
import { ConfigContext } from '@velinsi/smp-widgets-ui';
import { defaultHandleTournamentClick, getLabelValue } from '@sportal365/smp-widget-utils';

// Types/Constants
import { IRounds, IStage, ISubscriberInfo } from '../../../../../packages/types';
import { TOURNAMENT_ENTITY } from '../../../../../packages/constants/entityTypes';

interface Props {
  isDynamic?: boolean;
  showHeader?: boolean;
  stage?: IStage;
  tournament: {
    id?: string;
    title?: string;
    subTitle?: string;
    logo: string;
    tournamentUrl: string;
    standingsUrl: string;
    target: string;
  };
  round?: { label: string; value: string };
  rounds: IRounds[];
  setRound: (value: string) => void;
  setStage: (value: string) => void;
  handleClick: (info: ISubscriberInfo, clickType: string) => void;
}

const RoundHeader: FC<Props> = ({ isDynamic, showHeader, tournament, stage, round, rounds, setRound, setStage, handleClick }) => {
  const { dataLabels } = useContext(ConfigContext);
  const { id, title, subTitle, logo, tournamentUrl, standingsUrl, target } = tournament;
  const showRoundHeader = !isDynamic || !showHeader;

  const handleTournamentClick = () => (tournamentUrl ? defaultHandleTournamentClick(handleClick, id || '', title) : undefined);

  return (
    <div className='tournament-header-wrapper'>
      {showHeader && (
        <div className='tournament-container flex justify-between py-2 px-4 bg-rowBackgroundColor'>
          <a href={tournamentUrl} target={target} onClick={handleTournamentClick} className='flex items-center gap-2 no-underline'>
            <Image src={logo} alt={tournament.title} entityType={TOURNAMENT_ENTITY} className='tournament-logo h-7 w-7' />
            <div>
              <p className='tournament-name m-0 font-bold text-4 text-hiContrast'>{title}</p>
              <span className='tournament-country text-hiContrast text-3'>{subTitle}</span>
            </div>
          </a>
          <div className='tournament-round-dropdown-desktop-container flex gap-6 items-center'>
            {isDynamic && (
              <div className='hidden sm:flex'>
                <RoundDropdown currentStage={stage} currentRound={round} rounds={rounds} setRound={setRound} setStage={setStage} />
              </div>
            )}
            <a
              href={standingsUrl}
              target={target}
              onClick={handleTournamentClick}
              className='standings-anchor text-3 text-standingsLinkColor underline'
            >
              {getLabelValue(dataLabels?.standings, 'Standings')}
            </a>
          </div>
        </div>
      )}
      {!showRoundHeader && (
        <div className='tournament-round-dropdown-mobile-container py-2 px-4 flex bg-rowBackgroundColor sm:hidden'>
          <RoundDropdown currentStage={stage} currentRound={round} rounds={rounds} setRound={setRound} setStage={setStage} />
        </div>
      )}
      {showRoundHeader && (
        <div className='round-header flex items-center bg-primaryBackgroundColor py-0 px-4 h-[36px]'>
          <span className='round-name text-hiContrast text-2 font-semibold'>
            {stage?.name} - {getLabelValue(dataLabels?.round, 'Round')} {round?.label}
          </span>
        </div>
      )}
    </div>
  );
};

export default RoundHeader;
